import React from 'react';
import { Box, Typography } from '@mui/material';
import { getComponentRadius, BorderRadiusSize } from '../../../../../theme';
import { useNavigate } from 'react-router-dom';

const HeaderCenter: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: { xs: 'none', sm: 'flex' },
        position: 'absolute',
        left: 64,
        maxWidth: { xs: 'calc(100% - 124px)', sm: 'none' },
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.25,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        overflow: 'hidden',
      }}
      onClick={() => {
        navigate('/');
      }}
    >
      <Typography
        variant="h2"
        component="span"
        sx={{
          fontWeight: 800,
          color: 'text.primary',
          fontSize: 17,
          lineHeight: 1,
          letterSpacing: { xs: '-0.02em', sm: 'normal' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          textAlign: 'center',
        }}
      >
        STUDIO VAULT
      </Typography>
      <Typography
        variant="caption"
        sx={{
          display: { xs: 'none', sm: 'inline-flex' },
          fontWeight: 'bold',
          fontSize: 9,
          px: 0.75,
          py: 0.25,
          borderRadius: getComponentRadius(BorderRadiusSize.SMALL),
          border: '1px solid',
          borderColor: 'divider',
          color: 'text.secondary',
        }}
      >
        BETA
      </Typography>
    </Box>
  );
};

export default HeaderCenter;
